import { combineReducers } from 'redux';
import Header from './Header'
import main from './main'
import rights from './rights'
export default combineReducers({
    
    Header,
    main,
    rights,
});


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js